export class SignInfo {
	Latitude: number;
	Longitude: number;
	Name: string;
	City: string;
	State: string;
	Metropolitant: string;
	Id: number;
	DeviceTypeNameId: number;
	StatusNameId: number;
	Status: string;
	SignTypeId: number;
	SignTypeName: string;
	Make: string;
	Model: string;
	NumberOfLines: number;
	ModulePerLine: number;
	CharHeightPixels: number;
	CharWidthPixels: number;
	DisplayType: string;
	CurrentMessage: string;
	Beacon: string;
	DMSStatusTimePolled: string;
	SignGroupdName: string;
	SignGroupId: number;
	SignCanControl: number;
	LastRequestStatusId: number;
	offlineDate: string;
	isSelected: boolean;
	pingError: string;
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/domain-models/SignInfo.ts